import { Suspense, lazy } from 'react';
import { Navigate, useRoutes, useLocation } from 'react-router-dom';
import USER_ROLE from 'utils/constants/userRole';
import RoleBasedGuard from 'guards/RoleBasedGuard';
import CreatePriviledge from 'pages/priviledge/createPriviledge';
import CreateOrUpdateEmployee from 'pages/spEmployees/CreateOrUpdateEmployee';
import EmployeeList from 'pages/spEmployees/EmployeeList';
import CreateOrUpdateVehicle from 'pages/vehicles/CreateOrUpdateVehicle';
import LoadingScreen from '../components/LoadingScreen';
// layouts
// import MainLayout from '../layouts/main';
import DashboardLayout from '../layouts/dashboard';
import LogoOnlyLayout from '../layouts/LogoOnlyLayout';
import CommonLayout from '../layouts/CommonLayout';

// components
// import LoadingScreen from '../components/LoadingScreen';

// guards
import GuestGuard from '../guards/GuestGuard';
import AuthGuard from '../guards/AuthGuard';
// ----------------------------------------------------------------------

const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();
  const isDashboard = pathname.includes('/dashboard');

  return (
    <Suspense
      fallback={
        <LoadingScreen
          sx={{
            ...(!isDashboard && {
              top: 0,
              left: 0,
              width: 1,
              zIndex: 9999,
              position: 'fixed'
            })
          }}
        />
      }
    >
      <Component {...props} />
    </Suspense>
  );
};

export default function Router() {
  return useRoutes([
    {
      path: 'auth',
      children: [
        {
          path: 'login',
          element: (
            <GuestGuard>
              <Login />
            </GuestGuard>
          )
        },
        {
          path: 'forgot-password',
          element: (
            <GuestGuard>
              <ResetPassword />
            </GuestGuard>
          )
        },
        {
          path: 'verify',
          element: (
            <GuestGuard>
              <VerifyCode />
            </GuestGuard>
          )
        },
        {
          path: 'update-password',
          element: (
            <AuthGuard>
              <UpdatePassword />
            </AuthGuard>
          )
        },
        {
          path: 'seller-registration',
          element: (
            <GuestGuard>
              <SellerRegisteration />
            </GuestGuard>
          )
        }
      ]
    },
    // Dashboard Routes
    {
      path: 'dashboard',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      )
      // children: [{ element: <Navigate to="/dashboard/app" replace /> }, { path: 'app', element: <PageOne /> }]
    },
    {
      path: 'store',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { path: '', element: <StoreList /> },
        { path: 'edit', element: <CreateOrUpdateStore /> },
        { path: 'create', element: <CreateOrUpdateStore /> }
      ]
    },
    {
      path: 'dashboard',
      element: (
        <AuthGuard>
          {/* <RoleBasedGuard accessibleRoles={[USER_ROLE.ADMIN, USER_ROLE.OEM, USER_ROLE.EMPLOYEE]}> */}
          <DashboardLayout />
          {/* </RoleBasedGuard> */}
        </AuthGuard>
      ),
      children: [{ path: '', element: <Analytics /> }]
    },
    {
      path: 'customer',
      element: (
        // <RoleBasedGuard accessibleRoles={[USER_ROLE.ADMIN, USER_ROLE.EMPLOYEE]}>
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
        // </RoleBasedGuard>
      ),
      children: [{ path: '', element: <CustomerStoreList /> }]
    },
    {
      path: 'analytic',
      element: (
        // <RoleBasedGuard accessibleRoles={[USER_ROLE.ADMIN, USER_ROLE.EMPLOYEE]}>
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
        // </RoleBasedGuard>
      ),
      children: [
        { path: 'customer', element: <CustomerAnalyticList /> },
        { path: 'advertisement&&plusFeature', element: <PlusFeatureAnalyticList /> },
        { path: 'partner', element: <PartnerAnalyticList /> }
        // { path: 'buyVehicle', element: <BuyVehicleAnalyticList /> }
      ]
    },
    {
      path: 'vehicle',
      element: (
        // <RoleBasedGuard accessibleRoles={[USER_ROLE.ADMIN, USER_ROLE.EMPLOYEE]}>
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
        // </RoleBasedGuard>
      ),
      children: [
        { path: '', element: <VehicleList /> },
        { path: 'create', element: <CreateOrUpdateVehicle /> },
        { path: 'edit', element: <CreateOrUpdateVehicle /> }
      ]
    },
    {
      path: 'newvehicle',
      element: (
        // <RoleBasedGuard accessibleRoles={[USER_ROLE.ADMIN]}>
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
        // </RoleBasedGuard>
      ),
      children: [
        { path: 'create', element: <CreateNewVehicle /> },
        { path: 'edit', element: <CreateNewVehicle /> },
        { path: 'list', element: <NewVehicleList /> }
      ]
    },
    {
      path: 'product-services',
      element: (
        <RoleBasedGuard accessibleRoles={[USER_ROLE.ADMIN, USER_ROLE.EMPLOYEE]}>
          <AuthGuard>
            <DashboardLayout />
          </AuthGuard>
        </RoleBasedGuard>
      ),
      children: [
        { path: 'list', element: <ProductServiceList /> },
        { path: 'edit', element: <CreateProductService /> },
        { path: 'create', element: <CreateProductService /> },
        { path: 'create/prelist', element: <PrelistDataService /> }
      ]
    },
    {
      path: 'product',
      element: (
        // <RoleBasedGuard accessibleRoles={[USER_ROLE.OEM, USER_ROLE.EMPLOYEE]}>
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
        // </RoleBasedGuard>
      ),
      children: [
        { path: 'list', element: <ProductServiceList /> },
        { path: 'edit', element: <CreateProduct /> },
        { path: 'create', element: <CreateProduct /> },
        { path: 'create/prelist', element: <PrelistDataService /> }
      ]
    },
    {
      path: 'category',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { path: '', element: <StoreList /> },
        { path: 'create', element: <CreateOrUpdateCategory /> },
        { path: 'edit', element: <CreateOrUpdateCategory /> },
        { path: 'list', element: <CategoryList /> }
      ]
    },
    {
      path: 'advertisement',
      element: (
        // <RoleBasedGuard accessibleRoles={[USER_ROLE.ADMIN, USER_ROLE.EMPLOYEE]}>
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
        // </RoleBasedGuard>
      ),
      children: [
        { path: 'banner', element: <BannerList /> },
        { path: 'banner/edit', element: <CreateBanner /> },
        { path: 'banner/create', element: <CreateBanner /> }
      ]
    },
    {
      path: 'plusFeature',
      element: (
        <RoleBasedGuard accessibleRoles={[USER_ROLE.ADMIN, USER_ROLE.EMPLOYEE]}>
          <AuthGuard>
            <DashboardLayout />
          </AuthGuard>
        </RoleBasedGuard>
      ),
      children: [{ path: '', element: <PlusFeatureList /> }]
    },
    {
      path: 'event',
      element: (
        // <RoleBasedGuard accessibleRoles={[USER_ROLE.ADMIN, USER_ROLE.EMPLOYEE]}>
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
        // </RoleBasedGuard>
      ),
      children: [
        { path: 'partner/create', element: <CreateEvents /> },
        { path: 'customer/create', element: <CreateEvents /> },
        { path: 'edit', element: <CreateEvents /> }
        // { path: 'list', element: <EventList /> }
      ]
    },
    {
      path: 'offer',
      element: (
        // <RoleBasedGuard accessibleRoles={[USER_ROLE.ADMIN, , USER_ROLE.EMPLOYEE]}>
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
        // </RoleBasedGuard>
      ),
      children: [
        { path: 'partner/create', element: <CreateOffers /> },
        { path: 'customer/create', element: <CreateOffers /> },
        { path: 'edit', element: <CreateOffers /> },
        { path: 'list', element: <OfferList /> }
      ]
    },
    {
      path: 'privacy-policy',
      element: <CommonLayout />,
      children: [{ path: '', element: <PrivacyPolicy /> }]
    },
    {
      path: 'b2b',
      element: (
        // <RoleBasedGuard accessibleRoles={[USER_ROLE.ADMIN, USER_ROLE.EMPLOYEE]}>
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
        // </RoleBasedGuard>
      ),
      children: [
        { path: 'create', element: <CreateB2b /> },
        { path: 'edit', element: <CreateB2b /> },
        { path: 'list', element: <B2bList /> }
      ]
    },
    {
      path: 'report',
      element: (
        // <RoleBasedGuard accessibleRoles={[USER_ROLE.ADMIN]}>
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
        // </RoleBasedGuard>
      ),
      children: [{ path: '', element: <ReportList /> }]
    },
    {
      path: 'offerreport',
      element: (
        // <RoleBasedGuard accessibleRoles={[USER_ROLE.ADMIN]}>
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
        // </RoleBasedGuard>
      ),
      children: [{ path: '', element: <OfferReportList /> }]
    },
    {
      path: 'eventreport',
      element: (
        // <RoleBasedGuard accessibleRoles={[USER_ROLE.ADMIN]}>
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
        // </RoleBasedGuard>
      ),
      children: [{ path: '', element: <EventReportList /> }]
    },
    {
      path: 'ratingAndReviews',
      element: (
        // <RoleBasedGuard accessibleRoles={[USER_ROLE.ADMIN]}>
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
        // </RoleBasedGuard>
      ),
      children: [{ path: '', element: <RatingAndReviewsList /> }]
    },
    {
      path: 'user',
      element: (
        // <RoleBasedGuard accessibleRoles={[USER_ROLE.OEM, USER_ROLE.EMPLOYEE]}>
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
        // {/* </RoleBasedGuard> */}
      ),
      children: [{ path: '', element: <CreateUser /> }]
    },
    {
      path: 'business',
      element: (
        // <RoleBasedGuard accessibleRoles={[USER_ROLE.ADMIN, USER_ROLE.EMPLOYEE]}>
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
        // </RoleBasedGuard>
      ),
      children: [
        // { path: 'create', element: <CreateBusiness /> },
        { path: 'partner/create', element: <CreateBusiness /> },
        { path: 'customer/create', element: <CreateBusiness /> },
        { path: 'edit', element: <CreateBusiness /> }
        // { path: 'list', element: <BusinessList /> }
      ]
    },
    {
      path: 'school-auto',
      element: (
        // <RoleBasedGuard accessibleRoles={[USER_ROLE.ADMIN, USER_ROLE.EMPLOYEE]}>
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
        // {/* </RoleBasedGuard> */}
      ),
      children: [
        { path: 'partner/create', element: <CreateSchoolAuto /> },
        { path: 'customer/create', element: <CreateSchoolAuto /> },
        { path: 'edit', element: <CreateSchoolAuto /> }
        // { path: 'list', element: <SchoolAutoList /> }
      ]
    },
    {
      path: 'priviledge',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [{ path: '', element: <CreatePriviledge /> }]
    },
    {
      path: 'spEmployee',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { path: '', element: <EmployeeList /> },
        { path: 'create', element: <CreateOrUpdateEmployee /> },
        { path: 'edit', element: <CreateOrUpdateEmployee /> }
      ]
    },
    {
      path: '*',
      element: <LogoOnlyLayout />,
      children: [
        { path: '500', element: <Page500 /> },
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" replace /> }
      ]
    },
    {
      path: '/',
      element: <Navigate to="/dashboard" replace />
    },
    { path: '*', element: <Navigate to="/404" replace /> }
  ]);
}

// IMPORT COMPONENTS

// IMPORT COMPONENTS

// Authentication
const Login = Loadable(lazy(() => import('../pages/authentication/Login')));
// const Register = Loadable(lazy(() => import('../pages/authentication/Register')));
const ResetPassword = Loadable(lazy(() => import('../pages/authentication/ForgotPassword')));
const VerifyCode = Loadable(lazy(() => import('../pages/authentication/VerifyCode')));
const UpdatePassword = Loadable(lazy(() => import('../pages/authentication/UpdatePassword')));
const SellerRegisteration = Loadable(lazy(() => import('../pages/authentication/SellerRegisteration')));

// Analytics
const Analytics = Loadable(lazy(() => import('../pages/analytics/analytics')));

// Stores
// const CreateBuisness = Loadable(lazy(() => import('../pages/business/CreateBusiness')));
const StoreList = Loadable(lazy(() => import('../pages/stores/StoreList')));
const CreateOrUpdateStore = Loadable(lazy(() => import('../pages/stores/CreateOrUpdateStore')));

// product category
const CreateOrUpdateCategory = Loadable(lazy(() => import('../pages/category/CreateOrUpdateCategory')));
const CategoryList = Loadable(lazy(() => import('../pages/category/CategoryList')));

// Customer
const CustomerStoreList = Loadable(lazy(() => import('../pages/customers/CustomerStoreList')));

// Customer
const CustomerAnalyticList = Loadable(lazy(() => import('../pages/customer-analytics/CustomerAnalyticList')));
const PlusFeatureAnalyticList = Loadable(lazy(() => import('../pages/customer-analytics/PlusFeatureAnalyticList')));
const PartnerAnalyticList = Loadable(lazy(() => import('../pages/partner-analytics/PartnerAnalyticList')));
// const BuyVehicleAnalyticList = Loadable(lazy(() => import('../pages/buy-vehicle-analytics/BuyVehicleAnalyticList')));

// Vehicles
const VehicleList = Loadable(lazy(() => import('../pages/vehicles/VehicleList')));

// New Vehicles
const CreateNewVehicle = Loadable(lazy(() => import('../pages/new-vehicles/vehicle/CreateNewVehicle')));
const NewVehicleList = Loadable(lazy(() => import('../pages/new-vehicles/vehicle/NewVehicleList')));

// Product and Services
const CreateProductService = Loadable(lazy(() => import('../pages/products-services/CreateProductService')));
const PrelistDataService = Loadable(lazy(() => import('../pages/products-services/PrelistDataService')));
const ProductServiceList = Loadable(lazy(() => import('../pages/products-services/ProductServiceList')));

// Product and Services
const CreateProduct = Loadable(lazy(() => import('../pages/products-services/CreateProduct')));

// Bannerss
const BannerList = Loadable(lazy(() => import('../pages/advertisements/banners/BannerList')));
const CreateBanner = Loadable(lazy(() => import('../pages/advertisements/banners/CreateBanner')));

// Plus Feature
const PlusFeatureList = Loadable(lazy(() => import('../pages/plus-feature/plusFeature')));

// Events
const CreateEvents = Loadable(lazy(() => import('../pages/event/events/CreateEvent')));
const EventList = Loadable(lazy(() => import('../pages/event/events/EventList')));

// Offers
const CreateOffers = Loadable(lazy(() => import('../pages/offers/CreateOffer')));
const OfferList = Loadable(lazy(() => import('../pages/offers/PartnerOfferList')));

// B2B Partners
const CreateB2b = Loadable(lazy(() => import('../pages/b2b/CreateB2b')));
const B2bList = Loadable(lazy(() => import('../pages/b2b/B2bList')));

// Business Features
const CreateBusiness = Loadable(lazy(() => import('../pages/business-opportunity/business/CreateBusiness')));
const BusinessList = Loadable(lazy(() => import('../pages/business-opportunity/business/BusinessList')));

// School of Auto Features
const CreateSchoolAuto = Loadable(lazy(() => import('../pages/school-of-auto/school/CreateSchoolAuto')));
const SchoolAutoList = Loadable(lazy(() => import('../pages/school-of-auto/school/SchoolAutoList')));

// User
const CreateUser = Loadable(lazy(() => import('../pages/user/CreateUser')));

// Report
const ReportList = Loadable(lazy(() => import('../pages/report/ReportList')));
const OfferReportList = Loadable(lazy(() => import('../pages/offer-report/ReportList')));
const EventReportList = Loadable(lazy(() => import('../pages/event-report/ReportList')));

// Rating And Reviews
const RatingAndReviewsList = Loadable(lazy(() => import('../pages/rating-and-reviews/RatingAndReviewsList')));

// Error and other pages
const NotFound = Loadable(lazy(() => import('../pages/err-page/Page404')));
const Page500 = Loadable(lazy(() => import('../pages/err-page/Page500')));
const PrivacyPolicy = Loadable(lazy(() => import('../pages/common/PrivacyPolicy')));
